import { css } from '@firebolt-dev/css'
import { useEffect, useState } from 'react'
import { cls } from '../core/cls'

export function UIEditorFieldToggle({ trueLabel = 'Yes', falseLabel = 'No', value, onChange }) {
  return (
    <div
      className='fieldtog'
      css={css`
        flex: 1;
        display: flex;
        align-items: stretch;
        background: var(--bg4);
        border-radius: 5px;
        height: 34px;
        .fieldtog-btn {
          flex: 1;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          &.selected {
            background: var(--bg5);
          }
          &:hover {
            cursor: pointer;
          }
        }
      `}
    >
      <div className={cls('fieldtog-btn', { selected: !value })} onClick={() => onChange(false)}>
        <span>{falseLabel}</span>
      </div>
      <div className={cls('fieldtog-btn', { selected: value })} onClick={() => onChange(true)}>
        <span>{trueLabel}</span>
      </div>
    </div>
  )
}
